module.exports = __webpack_public_path__ + "static/1-c87201c62a8d7d1416dd29adcba263dc.jpg";